module.exports = __webpack_public_path__ + "img/training1.2ceccf17.png";